import React from "react";
import securityImage from "../../../assets/security.jpg";
import { Link } from "react-router-dom";

const EnsureSecurity = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="mvs-ensure-security-wrapper">
      <div className="security-details">
        <div className="row align-items-center justify-content-between">
          <div className="col-12 col-md-6 col-lg-8 col-xl-6">
            <div className="partnership__infos">
              <h2>How We Ensure Security in Machine Vision Solutions</h2>
              <p className="fs-lead my-4">
                Security is integrated into our machine vision systems through
                encrypted communication channels and secure data storage
                solutions. We ensure that all data collected during inspections
                is protected, with strict access controls to maintain the
                confidentiality and integrity of sensitive production data.
              </p>
              <div className="mt-10x">
                <Link
                  to="/contact-us"
                  className="link-btn btn link-btn--primary"
                  onClick={scrollHeader}
                >
                  <span>Contact Us</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              className="justify-content-center d-flex"
              style={{ position: "relative", opacity: 1, transform: "none" }}
            >
              <img src={securityImage} alt="security" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnsureSecurity;
